import React from 'react';
import { useLanguage } from '../../../language/hooks/useLanguageHook';
import { statsSectionData, StatCard } from '../../data/landingPageData'; // Import stats data and StatCard

const StatsSection = () => {
  const { t } = useLanguage();

  return (
    <div className="relative z-10 bg-gradient-to-r from-blue-600 to-blue-800 text-white scroll-fade-in">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-3 gap-12 text-center">
          {statsSectionData.map((stat) => (
            <StatCard
              key={stat.labelKey} // Use labelKey as unique identifier
              value={t(stat.valueKey)}
              label={t(stat.labelKey)}
              sublabel={t(stat.sublabelKey)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection; 